// remove undefiend values from object 
// remove empty object from array
export const cleanArray = function(array: any[]) {
    array.forEach((object)=>{
        cleanObject(object);
    })
    
    return array.filter(value => Object.keys(value).length !== 0);
}
function cleanObject(obj: any) {
    for (var propName in obj) { 
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
  }
  